export const extendedCountriesByZone = {
  Albania: ['Tirana'],
  Argentina: ['Buenos Aires'],
  Australia: ['Melbourne', 'Sidney'],
  Austria: ['Autriche'],
  Belarus: ['bielorussie', 'biélorussie'],
  Belgium: ['Belgique'],
  Bhutan: ['Bhoutan', 'Boutan', 'Butan'],
  Bolivia: ['La Paz'],
  Brazil: ['Rio', 'bresil', 'brésil'],
  'British Virgin Islands': ['Iles vierges britanniques'],
  Cambodia: ['cambodge'],
  Cambodge: ['Phnom Penh', 'Pnom Penh'],
  Canada: ['Montreal', 'Toronto'],
  'Cape Verde': ['Cap Vert'],
  'Cayman Islands': ['iles caimans'],
  'Central African Republic': ['République Centrafricaine'],
  Chad: ['Tchad'],
  China: ['Pekin', 'Shanghai', 'Shenzen'],
  Colombia: ['Bogota', 'Cartagena', 'Medellin'],
  Comoros: ['Comores'],
  'Costa Rica': ['San Jose'],
  Cyprus: ['Chypre'],
  'Czech Republic': [
    'Prague',
    'Republique Tcheque',
    'República Checa',
    'République Tchèque',
  ],
  Denmark: ['Copenhague'],
  'Dominican Republic': [
    'Punta Cana',
    'République dominicaine',
    'republique dominicaine',
  ],
  Ecuador: ['equateur'],
  Europe: [
    'Alemania',
    'Allemagne',
    'Alpes',
    'Amsterdam',
    'Athenes',
    'Autriche',
    'Barcelone',
    'Belgique',
    'Berlin',
    'Bratislava',
    'Bucarest',
    'Bucharest',
    'Canaries',
    'Chypre',
    'Copenhague',
    'Corse',
    'Dublin',
    'Espagne',
    'Grece',
    'Hamburg',
    'Helsinki',
    'Hongrie',
    'Ibiza',
    'Lisbonne',
    'Ljubljana',
    'London',
    'Londres',
    'Madrid',
    'Madère',
    'Majorque',
    'Marbella',
    'Milan',
    'Minorque',
    'Munich',
    'Mykonos',
    'Naples',
    'Oslo',
    'Paris',
    'Pays Bas',
    'Prague',
    'Republique Tcheque',
    'República Checa',
    'Riga',
    'Rome',
    'Roumanie',
    'Royaume Uni',
    'République Tchèque',
    'Sardaigne',
    'Sicile',
    'Stockholm',
    'Suisse',
    'Suède',
    'Séville',
    'Varsovie',
    'Warsaw',
    "code d'azur",
    'french alps',
    'french riviera',
    'london',
    'londres',
    'royaume uni',
  ],
  'Faroe Islands': ['iles feroe', 'Îles Féroé'],
  Finland: ['Helsinki'],
  France: ['Paris', "code d'azur", 'french alps', 'french riviera'],
  'French Antilles': [
    'Guyane francaise',
    'Guyane française',
    'Saint Barthelemy',
    'Saint Barthélémy',
    'Saint Martin',
    'St Barthelemy',
    'St Barthélémy',
    'St Martin',
  ],
  'French Polynesia': ['Bora Bora', 'Tahiti'],
  Germany: ['Alemania', 'Allemagne', 'Berlin', 'Hamburg', 'Munich'],
  Greece: ['Athenes', 'Grece'],
  Guernsey: ['Guernesey'],
  Guinea: ['Guinée'],
  Hungary: ['Hongrie'],
  Iceland: ['Islande'],
  India: ['Bombay', 'Mumbai', 'New Delhi', 'delhi'],
  Indonesia: ['Bali'],
  Ireland: ['Dublin'],
  'Isle of Man': ['ile de man'],
  Italy: ['Milan', 'Naples', 'Rome'],
  'Ivory Coast': ["Cote d'ivoire", "Côte d'Ivoire"],
  Japan: ['Tokyo', 'kyoto', 'osaka'],
  Korea: ['Coree', 'Corée', 'South Korea', 'seoul'],
  Kuwait: ['Koweit', 'Koweït'],
  Kyrgyzstan: ['Kirghizistan'],
  Latvia: ['Riga'],
  Mauritius: ['Ile Maurice'],
  Mexico: ['Cancun', 'Tulum', 'playa del carmen'],
  Moldova: ['Moldavie'],
  Morocco: [
    'Agadir',
    'Maroc',
    'Marrakech',
    'agadir',
    'casablanca',
    'marrakech',
  ],
  Myanmar: ['Birmanie'],
  Netherlands: ['Amsterdam', 'Pays Bas'],
  'Netherlands Antilles': ['Saint Martin', 'St Martin'],
  'New Zealand': ['Auckland', 'Nouvelle Zelande', 'Nueva Zelanda'],
  Nigeria: ['Lagos'],
  Norway: ['Oslo'],
  Oman: ['Muscat', 'Nizwa'],
  Palau: ['Palaos'],
  'Papua New Guinea': [
    'Papouasie Nouvelle Guinee',
    'Papouasie Nouvelle Guinée',
  ],
  Peru: ['Lima'],
  Poland: ['Varsovie', 'Warsaw'],
  Portugal: ['Lisbonne'],
  'Puerto Rico': ['Porto Rico'],
  Romania: ['Bucarest', 'Bucharest', 'Roumanie'],
  'Saudi Arabia': ['Arabie Saoudite'],
  Slovakia: ['Bratislava'],
  Slovenia: ['Ljubljana'],
  'Solomon Island': ['iles Salomon'],
  'South Africa': ['Afrique du sud'],
  'South Soudan': ['Soudan du Sud', 'Sudan'],
  Spain: ['Barcelone', 'Espagne', 'España', 'Madrid', 'Spain', 'Séville'],
  'Sri Lanka': ['Colombo'],
  Sweden: ['Stockholm', 'Suède'],
  Switzerland: ['Suisse'],
  Thailand: ['Bangkok', 'Phuket'],
  Turkey: ['Ankara', 'Cappadocia', 'Istanbul', 'Turquie'],
  Uganda: ['Ouganda'],
  'United Arab Emirates': [
    'Abou Dabi',
    'Abu Dhabi',
    'Doubai',
    'Dubai',
    'Emirats Arabes Unis',
  ],
  'United Kingdom': ['Royaume Uni', 'london', 'londres'],
  'United States': [
    'New York',
    'Nueva York',
    'estados unidos',
    'etats unis',
    'états unis',
  ],
  'Viet Nam': ['Hanoi', 'Vietnam', 'ho chi minh'],
};
